module.exports = __webpack_public_path__ + "assets/img/31_399.b3101783.jpg";